import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { IOption } from 'ng-select';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
  animations: [fadeInOutTranslate],
  providers: [NotificationToastService]
})
export class SettingsComponent implements OnInit {

  shipmentForm:FormGroup;
  generalForm:FormGroup;
  attendanceForm:FormGroup;
  constructor(private nf:NotificationToastService) { }

  ngOnInit() {
    this.createForm();
    this.fillForm();
  }
  createForm()
  {
    this.shipmentForm =  new FormGroup({
      routing :  new FormControl('Supervisor',Validators.required),
      assignmentTime : new FormControl('Business hours',Validators.required),
      assignmentReset : new FormControl('01:00 AM',Validators.required),
      scanning : new FormControl('none',Validators.required),
      assignmentType : new FormControl('Manual',Validators.required)
    });
    this.generalForm =  new FormGroup({
      branch :  new FormControl('Jeddah',Validators.required),
      country : new FormControl('India',Validators.required),
      currency : new FormControl('INR',Validators.required),
      businessHoursFrom : new FormControl('01:00 AM',Validators.required),
      businessHoursTo : new FormControl('05:00 AM',Validators.required)
    });
    this.attendanceForm =  new FormGroup({
      attendance :  new FormControl('system',Validators.required)
    });
  }
  fillForm()
  {
    firebase.database().ref("settings").child("shipment").on("value",(data)=>{
      this.shipmentForm.setValue(data.val());
    });
    firebase.database().ref("settings").child("general").on("value",(data)=>{
      this.generalForm.setValue(data.val());
    });
    firebase.database().ref("settings").child("attendance").on("value",(data)=>{
      this.attendanceForm.setValue(data.val());
    });
  }
  onSelectradioButton(scanning)
  {
    this.shipmentForm.get('scanning').setValue(scanning);
  }
  onSubmitShipmentForm()
  {
    if(this.shipmentForm.value)
    {
      firebase.database().ref("settings").child("shipment").update(this.shipmentForm.value).then((success)=>{
        this.nf.addToast({title:'Updated', msg:'Shipment settings have been updated successfully', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
      });
    }
  }
  onSubmitGeneralForm()
  {
    if(this.generalForm.value)
    {
      firebase.database().ref("settings").child("general").update(this.generalForm.value).then((success)=>{
        this.nf.addToast({title:'Updated', msg:'General settings have been updated successfully', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
      });
    }
  }
  onChangeCountry(country)
  {
    switch(country)
    {
      case 'India': this.generalForm.get('currency').setValue("INR");
      break;
      case 'Saudi Arabia': this.generalForm.get('currency').setValue("SAR");
      break;
      case 'United States': this.generalForm.get('currency').setValue("USD");
      break;
    }   
  }

  attopt: Array<IOption> = [
    {label: 'System', value: 'system'},
    {label: 'Manual', value: 'manual'}
  ];
  onSubmitAttendance()
  {
    if(this.attendanceForm.valid)
    {
      firebase.database().ref("settings").update(this.attendanceForm.value).then((success)=>{
        this.nf.addToast({title:'Updated', msg:'Attendance settings have been updated successfully', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
      });
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/settings/settings.component.ts